import React from 'react';

export const pageStyle = (maxWidth = 600): React.CSSProperties => ({
  padding: '2rem',
  maxWidth,
  margin: '0 auto',
});

export const formStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
};

export const labelStyle: React.CSSProperties = {
  display: 'block',
  marginBottom: '0.5rem',
  fontWeight: 'bold',
};

export const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '0.75rem',
  border: '1px solid #ccc',
  borderRadius: '4px',
  fontSize: '1rem',
  boxSizing: 'border-box',
  fontFamily: 'inherit',
  outline: 'none',
};

export const hintStyle: React.CSSProperties = {
  color: '#666',
  fontSize: '0.875rem',
  marginTop: '0.25rem',
};

export const errorBanner: React.CSSProperties = {
  padding: '1rem',
  backgroundColor: '#ffebee',
  color: '#c62828',
  borderRadius: '4px',
  border: '1px solid #ef5350',
};

export const cancelButton: React.CSSProperties = {
  padding: '0.75rem 1.5rem',
  backgroundColor: '#f5f5f5',
  color: '#333',
  border: '1px solid #ccc',
  borderRadius: '4px',
  cursor: 'pointer',
  fontSize: '1rem',
};

export function primaryButton(disabled?: boolean): React.CSSProperties {
  return {
    padding: '0.75rem 1.5rem',
    backgroundColor: disabled ? '#ccc' : '#1976d2',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontSize: '1rem',
  };
}

export const actionsStyle: React.CSSProperties = {
  display: 'flex',
  gap: '1rem',
  justifyContent: 'flex-end',
  marginTop: '1rem',
};

export function generatePassword() {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*';
  let password = '';
  password += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[Math.floor(Math.random() * 26)];
  password += 'abcdefghijklmnopqrstuvwxyz'[Math.floor(Math.random() * 26)];
  password += '0123456789'[Math.floor(Math.random() * 10)];
  password += '!@#$%^&*'[Math.floor(Math.random() * 8)];
  for (let i = 4; i < 12; i++) password += chars[Math.floor(Math.random() * chars.length)];
  return password.split('').sort(() => Math.random() - 0.5).join('');
}

export const DropZone: React.FC<{
  label: string;
  hint?: string;
  accept: string;
  file: File | null;
  onFile: (file: File | null) => void;
}> = ({ label, hint, accept, file, onFile }) => {
  const [active, setActive] = React.useState(false);
  return (
    <div>
      <label style={labelStyle}>{label}</label>
      <div
        onDragOver={(e) => {
          e.preventDefault();
          setActive(true);
        }}
        onDragLeave={() => setActive(false)}
        onDrop={(e) => {
          e.preventDefault();
          setActive(false);
          const next = e.dataTransfer.files?.[0];
          if (next) onFile(next);
        }}
        style={{
          border: `2px dashed ${active ? '#1976d2' : '#ccc'}`,
          borderRadius: '8px',
          padding: '2rem',
          textAlign: 'center',
          backgroundColor: active ? '#f5f5f5' : 'white',
        }}
      >
        {file ? (
          <div>
            <p>✅ {file.name}</p>
            <p style={{ fontSize: '0.9rem', color: '#666', margin: '0.5rem 0' }}>
              Size: {(file.size / (1024 * 1024)).toFixed(2)} MB
            </p>
            {file.type.startsWith('image/') && (
              <img
                src={URL.createObjectURL(file)}
                alt="Preview"
                style={{ maxWidth: 200, maxHeight: 200, marginTop: '1rem', borderRadius: 4 }}
              />
            )}
            <div>
              <button type="button" onClick={() => onFile(null)} style={{ color: 'red', background: 'none', border: 'none', cursor: 'pointer' }}>
                Remove
              </button>
            </div>
          </div>
        ) : (
          <div>
            <p>Drag and drop a file here, or click to select</p>
            {hint && <p style={{ fontSize: '0.9rem', color: '#666', marginTop: '0.5rem' }}>{hint}</p>}
            <input type="file" accept={accept} onChange={(e) => onFile(e.target.files?.[0] || null)} style={{ marginTop: '1rem' }} />
          </div>
        )}
      </div>
    </div>
  );
};
